export class MiddleEllipsisText {
    public full: string;
    constructor(public start: string, public middle: string, public end: string) {
        this.full = start + middle + end;
    }
}
